import { render } from "./AlternativesComparison.vue?vue&type=template&id=7e7638d7&scoped=true&ts=true"
import script from "./AlternativesComparison.vue?vue&type=script&lang=ts"
export * from "./AlternativesComparison.vue?vue&type=script&lang=ts"

import "./AlternativesComparison.vue?vue&type=style&index=0&id=7e7638d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e7638d7"]])

export default __exports__